<div class="home-block" id="szebit-in-numbers">
  <div class="home-container">
    <h1>SZEBIT számokban</h1>
    <div id="szebit-in-numbers-flex" [@countUp]="animate" (@countUp.start)="animateNumbers()">
      <div class="unit">
        <p class="number" data-target="">{{ numbers[0] }}.</p>
        <p>SZEBIT</p>
      </div>
      <div class="unit">
        <p class="number" data-target="">{{ numbers[1] }}+</p>
        <p>LÁTOGATÓ</p>
      </div>
      <div class="unit">
        <p class="number" data-target="">{{ numbers[2] }}+</p>
        <p>PARTNER</p>
      </div>
      <div class="unit">
        <p class="number" data-target="">{{ numbers[3] }} NAP</p>
      </div>
    </div>
  </div>
</div>
